import customaxios from ".";
import axios from "axios";
import store from "../store";

const appState = store.getState();

const baseURL = `${appState.server.serverProtocol}://${appState.server.serverUrl}:${appState.server.serverPort}/api/v1`;
export const login = (data: unknown) => {
  return axios({
    method: "POST",
    url: `${baseURL}/login`,
    data,
  });
};
export const refreshToken = () => {
  const refreshToken = localStorage.getItem("refreshToken");
  if (!refreshToken) {
    throw new Error("No refresh token found");
  }
  return customaxios({
    method: "POST",
    url: "/refresh-token",
    headers: {
      Authorization: `${refreshToken}`,
    },
  });
};
export const changePassword = (data: unknown) => {
  return customaxios({
    method: "POST",
    url: "/change-password",
    data,
  });
};

export const contactUs = (data: unknown) => {
  return axios({
    method: "POST",
    url: `${baseURL}/contact-us`,
    data,
  });
};

export const getCompanyNamesInRequestAccess = () => {
  return axios({
    method: "GET",
    url: `${baseURL}/request-access/company-names`,
  });
}
export const requestAccess = (data: any) => {
  return axios({
    method: "POST",
    url: `${baseURL}/request-access`,
    data,
  });
};